import { render, staticRenderFns } from "./recordsList.vue?vue&type=template&id=2779938a&scoped=true&"
import script from "./recordsList.vue?vue&type=script&lang=js&"
export * from "./recordsList.vue?vue&type=script&lang=js&"
import style0 from "./recordsList.vue?vue&type=style&index=0&id=2779938a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779938a",
  null
  
)

export default component.exports